// extracted by mini-css-extract-plugin
export var increaseprogress = "ProgressBar-module--increaseprogress--832d0";
export var progress = "ProgressBar-module--progress--af557";
export var progressStarted = "ProgressBar-module--progress-started--f206e";
export var well = "ProgressBar-module--well--3ef8f";